import { render, staticRenderFns } from "./club-center-settings.vue?vue&type=template&id=0d17cd02&scoped=true&"
import script from "./club-center-settings.vue?vue&type=script&lang=ts&"
export * from "./club-center-settings.vue?vue&type=script&lang=ts&"
import style0 from "./club-center-settings.vue?vue&type=style&index=0&id=0d17cd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17cd02",
  null
  
)

export default component.exports